import {CardLinkWrapper} from '@hconnect/uikit/src/lib2'
import {SxProps, Theme} from '@mui/material'
import {EventsSummaryContainer} from '@widgets/events-summary'

import {useOptimizationSpecialistTimeRange} from '../hooks'

type Props = {
  plantId: string
  cardBoxSx?: SxProps<Theme>
  placeholderWrapperSx?: SxProps<Theme>
  cockpitHref?: string
}

export const EventsContainer: React.FC<Props> = ({
  plantId,
  cardBoxSx,
  placeholderWrapperSx,
  cockpitHref
}) => {
  const {start, end} = useOptimizationSpecialistTimeRange(plantId)

  return (
    <CardLinkWrapper href={cockpitHref} data-test-id="events-summary-card-link-to-shifthandover">
      <EventsSummaryContainer
        plantId={plantId}
        from={start}
        to={end}
        cardBoxSx={cardBoxSx}
        placeholderWrapperSx={placeholderWrapperSx}
      />
    </CardLinkWrapper>
  )
}
